module.exports = __webpack_public_path__ + "static/media/searchIcon.f26a8033.svg";